import type { CSSProperties } from "react";
import { motion } from "motion/react";
import { cn } from "./cn";

/** The mark's geometry in its 40×40 box: two bars slanted at both ends, the right one higher and longer. Every drawing of the mark uses it. */
export const MARK = {
  parts: [
    { d: "M10.2 14.3 19.3 9.9V31.6L10.2 36z", fill: "var(--accent)" },
    { d: "M20.7 8.4 29.8 4V29.6L20.7 34z", fill: "var(--primary)" },
  ],
  /** Empty units on each side of the bars, which a lockup trims so spacing is measured from the ink. */
  inset: 10.2,
} as const;

export type MarkProps = {
  size?: number;
  /** Snaps in with a short skew on mount. */
  pop?: boolean;
  className?: string;
  style?: CSSProperties;
};

/** The Headcount mark: an orange bar and a higher, longer blue bar, both slanted at the ends. */
export function Mark({ size = 24, pop, className, style }: MarkProps) {
  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      aria-hidden
      className={cn("shrink-0", className)}
      style={style}
      initial={pop ? { scale: 0.5, skewY: -12 } : false}
      animate={pop ? { scale: 1, skewY: 0 } : undefined}
      transition={{ type: "spring", stiffness: 420, damping: 20 }}
    >
      {MARK.parts.map((p) => (
        <path key={p.d} d={p.d} fill={p.fill} />
      ))}
    </motion.svg>
  );
}
